import clsx from 'clsx';

import styles from './CoBrandingLogo.module.css';

type Props = {
  className?: string;
  branding: Branding;
};

type Branding = {
  name: string;
  logoSidebar: {
    url: string;
  };
  logoContent: {
    url: string;
  };
};

const Logo = ({ url, className }: { url: string; className?: string }) => {
  return <img alt={'logo'} className={clsx(styles.logo, className)} src={url} />;
};

export const CoBrandingLogoSidebar = ({ className, branding }: Props) => {
  return <Logo className={clsx(styles.logoSidebar, className)} url={branding.logoSidebar.url} />;
};

export const CoBrandingLogoContent = ({ className, branding }: Props) => {
  return <Logo className={clsx(styles.logoContent, className)} url={branding.logoContent.url} />;
};

export const CoBrandingLogoConfirmation = ({ className, branding }: Props) => {
  return <Logo className={className} url={branding.logoContent.url} />;
};

export const CoBrandingLogoReceipt = ({ className, branding }: Props) => {
  return <Logo className={clsx(styles.logoReceipt, className)} url={branding.logoSidebar.url} />;
};

export const CoBrandingLogoPartnershipExplained = ({ className, branding }: Props) => {
  return <Logo className={clsx(styles.logoPartnershipExplained, className)} url={branding.logoSidebar.url} />;
};
